import type JSZip from "jszip";
import { useCallback } from "react";
import { useMediaDataRoomInsightsData } from "features/mediaDataRoom/contexts";
import {
  MediaDataRoomJobInput,
  useMediaDataRoomJob,
} from "features/mediaDataRoom/hooks/v3";
import { MediaDataRoomVersion } from "features/mediaDataRoom/models";

interface ModelPerformanceReportV3GenerationHookPayload {
  dataRoomId: string;
  skip: boolean;
}

const useModelPerformanceReportGeneration = ({
  dataRoomId,
  skip,
}: ModelPerformanceReportV3GenerationHookPayload) => {
  const { session, publishedDatasetsHashes } = useMediaDataRoomInsightsData(
    MediaDataRoomVersion.v3
  );
  const transform = useCallback(async (zip: JSZip): Promise<string> => {
    const performanceReportFile = zip.file("model_quality.json");
    if (performanceReportFile === null) {
      throw new Error("model_quality.json not found in zip");
    }
    let performanceReport: string;
    try {
      performanceReport = JSON.parse(
        await performanceReportFile.async("string")
      ) as string;
    } catch {
      throw new Error("Failed to parse model_quality.json");
    }
    if (!performanceReport) {
      throw new Error("Model quality report is empty");
    }
    return performanceReport;
  }, []);

  const computeJob = useMediaDataRoomJob({
    input: MediaDataRoomJobInput.create(
      "retrieveModelQualityReport",
      dataRoomId,
      publishedDatasetsHashes
    ),
    requestCreator: MediaDataRoomJobInput.emptyRequestCreator,
    session,
    skip,
    transform,
  });

  return computeJob;
};

export default useModelPerformanceReportGeneration;
